import React from 'react';

import { useContainer } from 'unstated-next';

import UnauthorizedUserAccessView from '../../../AdminSettings/SettingsPanels/UnauthUserAccessView';
import { ClassContainer } from '../../ClassContainer';

const UnauthUserAccessClassSetting: React.FC = () => {
    const { watch, setValue } = useContainer(ClassContainer);

    const setting = watch('unauthUserAccess');
    const text = watch('unauthUserText');

    const setSetting = (newSetting) => setValue('unauthUserAccess', newSetting);
    const setText = (newText) => setValue('unauthUserText', newText);

    return <UnauthorizedUserAccessView setting={setting} setSetting={setSetting} text={text} setText={setText} />;
};

export default UnauthUserAccessClassSetting;
